/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular.module('app.services', []);



// WEBPACK FOOTER //
// ./scripts/shared/services/module.js